import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { noop } from 'lodash'
import Modal from '@ublique/components/LoadingModal'

const ConfirmChangesModal = ({ open, close, data }) => {
  const { t } = useTranslation('Document')
  const [loading, setLoading] = useState(false)

  const { title, message, onConfirm, onCancel } = data

  const onConfirmHandler = () => {
    setLoading(true)
    // The modal is not closed if onConfirm throws an error
    // to properly open another modal with the error details
    Promise.resolve(onConfirm()).then(close).catch(noop)
  }

  const onCancelHandler = () => {
    setLoading(true)
    // The modal is not closed if onCancel throws an error
    // to properly open another modal with the error details
    Promise.resolve(onCancel()).then(close).catch(noop)
  }

  return (
    <Modal
      open={open}
      confirmLoading={loading}
      className='modal-confirm'
      hasScrollingContent={false}
      iconDescription={t('close')}
      modalHeading={title ? t(`${title}`) : t('confirm')}
      onRequestClose={close}
      onRequestSubmit={onConfirmHandler}
      onSecondarySubmit={onCancelHandler}
      primaryButtonText={t('confirm')}
      confirmLoadingMessage={t('confirm')}
      secondaryButtonText={t('discard')}
      selectorPrimaryFocus='[data-modal-primary-focus]'
    >
      <p className='bx--modal-content__text'>{t(message)}</p>
    </Modal>
  )
}

export default ConfirmChangesModal
